import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BarGraph from "../../../general/BarGraph";
import BigCard from "../../../general/BigCard";
import styles from "./GeneralConditionL2.module.css";
import GCMap from "./maps/GCMap";

function GeneralConditionL2({
  distrito,
  menuFilterParams,
  searchControl,
  generalConditionValues,
  setCaptacaoAguaImage
}) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);
  const [captacaoAgua, setCaptacaoAgua] = useState(null);
  const [loading, setLoading] = useState(true);

  const { selectedOption, searchInput } = searchControl;
  const { category, subcategoria, natureza } = menuFilterParams;
  const {
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
  } = generalConditionValues;

  const inscricao = Functions.getInscricaoParam(selectedOption, searchInput);
  const proprietario = Functions.getProprietarioParam(
    selectedOption,
    searchInput
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [captacaoAgua, numeroPropriedades, areaMedia] = await Promise.all(
          [
            Api.getCaptacaoAgua(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              carroProprioValue,
              energiaEletricaValue,
              abastecimentoAguaValue,
              tipoFossaValue,
              descarteLixoValue,
              descarteEsgotoValue
            ),
            Api.getNumeroPropriedades2(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              carroProprioValue,
              energiaEletricaValue,
              abastecimentoAguaValue,
              tipoFossaValue,
              descarteLixoValue,
              descarteEsgotoValue
            ),
            Api.getAreaMedia2(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              carroProprioValue,
              energiaEletricaValue,
              abastecimentoAguaValue,
              tipoFossaValue,
              descarteLixoValue,
              descarteEsgotoValue
            ),
          ]
        );
        setCaptacaoAgua(
          Functions.buildBarGraph(captacaoAgua, "Captação de Água")
        );
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
  ]);

  if (loading) return <div className={styles.generalConditionL2}></div>;

  return (
    <div className={styles.generalConditionL2}>
      <div className={styles.cards}>
        <div className={styles.bigCard}>
          <BigCard
            name="Propriedades"
            value={numeroPropriedades?.value ?? "..."}
          />
        </div>
        <div className={styles.card}>
          <BigCard
            name={
              <>
                Área Média
                <br />
                (ha)
              </>
            }
            value={Number(areaMedia?.value ?? 0.0).toFixed(2)}
          />
        </div>
      </div>

      <div className={styles.map}>
        <GCMap
          distrito={distrito}
          category={category}
          subcategoria={subcategoria}
          natureza={natureza}
          selectedOption={selectedOption}
          searchInput={searchInput}
          carroProprioValue={carroProprioValue}
          energiaEletricaValue={energiaEletricaValue}
          abastecimentoAguaValue={abastecimentoAguaValue}
          tipoFossaValue={tipoFossaValue}
          descarteLixoValue={descarteLixoValue}
          descarteEsgotoValue={descarteEsgotoValue}
        />
      </div>

      <div className={styles.barGraph}>
        <div className={styles.graph}>
          <BarGraph
            data={captacaoAgua}
            text="CAPTAÇÃO DE ÁGUA"
            onImageReady={setCaptacaoAguaImage}
          />
        </div>
      </div>
    </div>
  );
}

export default GeneralConditionL2;
